<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items" />
        <b-card>
          <span v-if="ccl_lists.total > 0"   class="badge badge-success">Total Search Data Found: {{ ccl_lists.total }}</span>
          <div class="mb-1" v-if="ccl_lists.total > 0" >
            <download-excel
                class = "btn btn-success float-right mb-1"
                :fetch = "fetchData"
                :fields = "ccl_fields"
                :meta="json_meta"
                :before-generate="startDownload"
                :before-finish="finishDownload"
                worksheet = "ccl"
                name = "ccl.xls">
              Download Excel
            </download-excel>
          </div>

          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped" id="titledExcel">
              <thead>
              <tr>
                <th>Sl</th>
                <th>CCL No.</th>
                <th>Mouza</th>
                <th>Plot</th>
                <th>CCL Amount</th>
                <th>CCL Type</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(ccl_list, index) in ccl_lists.data" :key="index">
                <td>{{ ccl_lists.from + index }}</td>
                <td>
                  {{ ccl_list.ccl_no }}
                </td>
                <td>{{ ccl_list.mouza_desc}}</td>
                <td>{{ ccl_list.plot_no }}</td>
                <td>{{ ccl_list.amount }}</td>
                <td>{{ ccl_list.ccl_type}}</td>

              </tr>
              </tbody>
            </table>
            <div v-if="loader" class="loader">Loading...</div>
            <h5 class="text-center text-secondary" v-if="ccl_lists.total === 0 || !flag">
              No Data Found
            </h5>
            <div class="float-right mt-1">
              <pagination :data="ccl_lists" :limit="2" @pagination-change-page="getResults"></pagination>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <view-modal
        :ccl_list="ccl_list"
    ></view-modal>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config.json";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import XLSX from 'xlsx';
import viewModal from './modal/viewModal'

export default {
  page: {
    title: "List of Total CCL by Mouza",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, viewModal},
  data() {
    return {
      title: "List of Total CCL by Mouza",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "List of Total CCL by Mouza",
          active: true
        }
      ],
      plots: [],
      districts: [],
      all_upazilas: [],
      mouzas: [],
      land_types: [],
      ccl_types: [],
      ccl_lists: {},
      flag: false,
      loader: false,
      ccl_list: {},
      ccl_fields: {
        'CCL No.': 'ccl_no',
        'Mouza': 'mouza.mouza_desc',
        'Plot': 'plot.plot_no',
        'Amount': 'amount',
        'CCL Type': 'ccl_type.ccl_type_desc',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
    };
  },

  mounted() {
    this.mouza_id = this.$route.params.mouza_id;
    this.search();
  },
  methods: {

    search() {
      let formData = new FormData();
      formData.append("mouza_id", this.mouza_id);
      this.flag = true
      this.loader = true
      http.post("api/ccl/view/collected/mouza", formData).then(response => {
        if (!response.error) {
          this.flag = true;
          this.loader = false
          this.ccl_lists = response.data.ccl_lists;
        }
      });
    },
    getResults(page = 1) {
      let formData = new FormData();
      formData.append("mouza_id", this.mouza_id);
      this.flag = true
      this.loader = true
      http.post('api/ccl/view/collected/mouza?page=' + page, formData)
          .then(response => {
            this.flag = true;
            this.loader = false
            this.ccl_lists = response.data.ccl_lists;
          });
    },
    onexport(evt) {
      var tbl = document.getElementById('titledExcel');
      var wb = XLSX.utils.table_to_book(tbl);
      XLSX.writeFile(wb, "ccl.xlsx");
    },
    viewCcl(ccl_list){
      this.ccl_list = {};
      this.ccl_list = ccl_list;
      this.$root.$emit("bv::show::modal", "ccl-view-page-modal");
    },

    async fetchData(){
      const response = await http.post("api/ccl/view/download", this.search_data);
      return response.data.ccl_lists;
    },
    startDownload() {
      alert('It will take some time, Loading...');
    },
    finishDownload() {
      alert('Download completed.');
    },
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    },
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
<style src="vue-select/dist/vue-select.css"></style>
